import React from 'react';
import Plot from 'react-plotly.js';
import * as Const from '../../../utils/Const';

interface TrainingAnswerTimeProps {
  data?: any; // 引数として渡すプロパティ
}

interface PlotlyData {
  [Const.KeyAreaName]: string;
  [key: string]: any;
}

function transformToPlotlyData(sqlData: any[], dataTypeKey: string): { selectData: PlotlyData[] } {
  if (!sqlData || sqlData.length === 0) return { selectData: [] };

  // ヘッダーを取得
  const selectData = sqlData.map((row) => ({
    [Const.KeyAreaName]: row[Const.KeyAreaName],
    [dataTypeKey]: row[dataTypeKey],
  }));
  console.log('plotlyData header dataTypeKey', dataTypeKey);
  console.log('plotlyData header', selectData);

  return { selectData };
}

export const TrainingAnswerTime: React.FC<TrainingAnswerTimeProps> = ({ data }) => {
  const dataList = data || [];
  const plotlyDataOK = transformToPlotlyData(dataList, Const.KeyAverageAnswerTimeOK);
  const plotlyDataNG = transformToPlotlyData(dataList, Const.KeyAverageAnswerTimeNG);

  const OKgraphData: any[] = [
    {
      type: 'bar',
      x: plotlyDataOK.selectData.map((item) => item[Const.KeyAverageAnswerTimeOK]),
      y: plotlyDataOK.selectData.map((item) => item[Const.KeyAreaName]),
      //      orientation: 'h',
      text: plotlyDataOK.selectData.map((item) => item[Const.KeyAverageAnswerTimeOK]), // 棒グラフ上に表示する数値
      textposition: 'outside', // 数値を棒の外側に表示
      textfont: {
        size: 50, // 数値のフォントサイズを指定
      },
      name: '正解',
      marker: {
        color: `${Const.GraphBaseColor}`, // 棒グラフの色を指定
      },
    },
  ];

  const NGgraphData: any[] = [
    {
      type: 'bar',
      x: plotlyDataNG.selectData.map((item) => item[Const.KeyAverageAnswerTimeNG]),
      y: plotlyDataNG.selectData.map((item) => item[Const.KeyAreaName]),
      orientation: 'h',
      text: plotlyDataNG.selectData.map((item) => item[Const.KeyAverageAnswerTimeNG]), // 棒グラフ上に表示する数値
      textposition: 'outside', // 数値を棒の外側に表示
      textfont: {
        size: 50, // 数値のフォントサイズを指定
      },
      name: '不正解',
      marker: {
        color: `${Const.GraphSubColor}`, // 棒グラフの色を指定
      },
    },
  ];

  if (dataList.length === 0) return <></>;

  return (
    <>
      <details className="rounded-3xl shadow-custom-lg overflow-hidden bg-white ml-2 mr-4 mt-2 mb-8">
        <summary className="cursor-pointer px-4 py-3 text-4xl">回答時間分布</summary>
        <Plot
          data={[NGgraphData[0], OKgraphData[0]]}
          layout={{
            xaxis: {
              title: {
                text: '回答時間（秒）', // X軸の単位
                font: { size: 20 }, // X軸タイトルのフォントサイズ
              },
              tickfont: {
                size: 20, // X軸の値のフォントサイズを指定
              },
            },
            yaxis: {
              automargin: true, // Y軸のマージンを自動調整
              tickmode: 'array', // すべての値を表示
              tickfont: {
                size: 20, // Y軸の値のフォントサイズを指定
              },
              ticklabelposition: 'inside', // Y軸の文字を左寄せに設定
            },
            legend: {
              font: {
                size: 20, // 凡例の文字サイズを指定
              },
              traceorder: 'reversed', // データの順序に基づいて凡例を表示
            },
            margin: {
              t: 20, // 上部のマージンを確保
              l: 300, // 必要最小限の左マージン
              r: 40,
              b: 80,
            },
            autosize: true,
          }}
          config={{
            responsive: true, // レスポンシブデザインを有効にする
            displayModeBar: false, // モードバーを非表示にする
            displaylogo: false, // Plotlyロゴを非表示にする
            staticPlot: true, // プロットを静的にする
          }}
          style={{ width: '100%', height: '100%', minHeight: '450px' }}
        />
      </details>
    </>
  );
};
